import * as React from 'react';

const categories = [
  { id: 'top', name: 'Top', emoji: '👒' },
  { id: 'accessories', name: 'Accessories', emoji: '🕶️' },
  { id: 'facialHair', name: 'Facial Hair', emoji: '🧔' },
  { id: 'clothe', name: 'Clothes', emoji: '👕' },
  { id: 'eyes', name: 'Eyes', emoji: '👀' },
  { id: 'eyebrows', name: 'Eyebrows', emoji: '👁️' },
  { id: 'mouth', name: 'Mouth', emoji: '👄' },
  { id: 'skin', name: 'Skin', emoji: '👩' },
];

export default class AvatarCustomizationGrid extends React.Component {
  handleCategoryClick = (category) => {
    this.props.onCategorySelect(category.id); // Pass only the category id
  };

  render() {
    return (
      <div className="d-flex flex-wrap justify-content-center gap-2 my-3">
        {categories.map((category) => (
          <button
            key={category.id}
            className="btn btn-outline-secondary rounded-pill d-flex align-items-center justify-content-center category-btn px-3 py-2"
            onClick={() => this.handleCategoryClick(category)}
            title={category.name}
          >
            <span className="d-inline d-md-none" style={{ fontSize: '1.5rem' }}>
              {category.emoji}
            </span>
            <span className="d-none d-md-inline">
              {category.emoji} {category.name}
            </span>
          </button>
        ))}
      </div>
    );
  }
}
